export default "__VITE_ASSET__aacd9fcc__"